export default {"src":"/_next/static/media/access-management.c290dbf5.svg","height":739,"width":650,"blurWidth":0,"blurHeight":0};